import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { TVApp } from "./tv/TVApp";
import "./styles.css";
import "./tv/tv.css";

const screen = new URLSearchParams(window.location.search).get("screen");
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {screen === "tv" ? <TVApp /> : <App />}
  </StrictMode>
);
